define('container/argResolvers/ContainerArgResolver',['bluebird'], function(Promise) {

    'use strict';

    function ContainerArgResolver() {
    }

    ContainerArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition === 'container';
    };

    ContainerArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {
        return Promise.resolve(extensionApi.container);
    };

    return ContainerArgResolver;
});

